import {
  dateTimeStringToDate,
  formatDateTime,
} from "../../../../common/helpers/time";

class AdminStudentsInvitationsController {
  constructor(InvitationsModel, FlashService) {
    this.InvitationsModel = InvitationsModel;
    this.FlashService = FlashService;
    this.invitiations = [];
    this.loading = true;
    this.submitting = false;
    this.invite = {
      type: "email",
    };

    InvitationsModel.get().then((response) => {
      this.invitations = response.invitations.map((invite) => {
        invite.created_at = invite.created_at
          ? formatDateTime(
              dateTimeStringToDate(invite.created_at),
              "MM/DD/YYYY h:mm A",
            )
          : "";
        return invite;
      });
      this.loading = false;
    });
  }

  sendInvitation() {
    const data = {
      invite_type: this.invite.type,
    };
    if (this.invite.type === "email") {
      data.email = this.invite.email;
    }
    if (this.invite.type === "phone") {
      data.phone = this.invite.phone;
    }
    this.submitting = true;
    this.InvitationsModel.sendInvitation(data)
      .then((response) => {
        const invite = Object.assign({}, this.invite);
        invite.accepted = false;
        this.submitting = false;
        this.invitations.unshift(invite);
        this.FlashService.setMessage({
          type: "success",
          message: response.message,
        });
        delete this.invite.phone;
        delete this.invite.email;
      })
      .catch((response) => {
        this.submitting = false;
      });
  }
}

AdminStudentsInvitationsController.$inject = [
  "InvitationsModel",
  "FlashService",
];

export default AdminStudentsInvitationsController;

